import { Box, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import { FC, useContext } from "react";

import Loader from "../../../../components/Loader";
import { CoachSlot } from "../types";
import { CellContext } from "../CalendarGrid";

const useStyles = makeStyles((theme) => ({
  slot: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    borderRadius: 5,
    flexBasis: 50,
    textAlign: "center",
    color: theme.palette.grey[50],
    background: theme.palette.grey[600],
  },
  reservedSlot: {
    background: theme.palette.error.main,
  },
}));

const CellManageSlotsPreview: FC<CalendarGridCellManageSlotsPreviewProps> = ({ slots, loading }) => {
  const classes = useStyles({});
  const { selectedCellDate } = useContext(CellContext);

  return (
    <>
      {selectedCellDate ? (
        slots.has(`${selectedCellDate.valueOf()}`) ? (
          <Box display="flex" flexWrap="wrap" m={-1} mt={2}>
            {slots.get(`${selectedCellDate.valueOf()}`)?.map((slot, i) => (
              <Box
                key={`${i}`}
                className={clsx([
                  classes.slot,
                  {
                    [classes.reservedSlot]: slot.reserved,
                  },
                ])}
              >
                {slot.startTime.toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hourCycle: "h23",
                })}
              </Box>
            ))}
          </Box>
        ) : (
          <Loader loading={loading} size={26} height="auto">
            <Box my={2} display="flex" justifyContent="center" alignItems="center">
              <Typography color="textSecondary">No slots defined</Typography>
            </Box>
          </Loader>
        )
      ) : null}
    </>
  );
};

interface CalendarGridCellManageSlotsPreviewProps {
  slots: Map<string, CoachSlot[]>;
  loading: boolean;
}

export default CellManageSlotsPreview;
